import render from "./render";

var observe = function observe() {
  var observer = new window.MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && Object.keys(mutation.target.dataset).join(',').indexOf('trimmings') > -1) {
        render(mutation.target.parentNode || mutation.target);
      } else if (mutation.type === 'childList') {
        render(mutation.target);
      }
    });
  });
  observer.observe(document.querySelector('body'), {
    attributes: true,
    childList: true,
    subtree: true
  });
};

export default observe;